// @flow

import * as React from "react"
import type {Task} from "../types"
import Icon from "./icon"
import {withTranslation} from "react-i18next"
import ClassNames from "classnames"

type Props = {
  task: Task,
  t: any,
  onUpdate: (Task) => void,
  onDelete: (number) => void,
}

type State = {
  isEditing: boolean,
  description: string,
}

class TaskListItem extends React.Component<Props, State> {
  handleEdit: () => void
  handleToggle: () => void
  handleSave: () => void
  handleDelete: () => void
  handleDescriptionUpdate: (SyntheticInputEvent<HTMLTextAreaElement>) => void

  input: ?HTMLTextAreaElement

  constructor(props: Props) {
    super(props)
    this.state = {
      isEditing: false,
      description: props.task.description,
    }
    this.handleEdit = this.handleEdit.bind(this)
    this.handleToggle = this.handleToggle.bind(this)
    this.handleSave = this.handleSave.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.handleDescriptionUpdate = this.handleDescriptionUpdate.bind(this)
  }

  handleEdit() {
    this.setState({isEditing: true}, () => {
      if (this.input) {
        this.input.focus()
      }
    })
  }

  handleToggle() {
    const {task, onUpdate} = this.props
    this.setState({isEditing: false})
    onUpdate({...task, isDone: !task.isDone})
  }

  handleDelete() {
    const {task, onDelete} = this.props
    onDelete(task.id)
  }

  handleSave() {
    const {task, onUpdate} = this.props
    this.setState({isEditing: false})
    onUpdate({...task, description: this.state.description})
  }

  handleDescriptionUpdate(e: SyntheticInputEvent<HTMLTextAreaElement>) {
    this.setState({
      description: e.currentTarget.value,
    })
  }

  render() {
    const {t, task} = this.props
    const {isEditing, description} = this.state
    const className = ClassNames("task-list-item", {
      "is-editing": isEditing,
      "is-done": task.isDone,
    })
    return (
      <li className={className}>
        <div className="task-list-item-checkbox" onClick={this.handleToggle}>
          <Icon name="icon-check" className="checkbox-check" />
        </div>
        <div className="task-list-item-details">
          <div
            className="task-list-item-details-text"
            onClick={this.handleEdit}
          >
            {task.description}
          </div>
          <div className="task-list-item-details-edits">
            <textarea
              className="form-control"
              ref={(input) => (this.input = input)}
              value={description}
              onChange={this.handleDescriptionUpdate}
            />
            <button className="btn btn-primary" onClick={this.handleSave}>
              {t("tasks.item.save")}
            </button>
          </div>
          <Icon
            name="icon-trash"
            className="task-list-item-delete"
            onClick={this.handleDelete}
          />
        </div>
      </li>
    )
  }
}

export default withTranslation()(TaskListItem)
